<template>
    <div class="flex flex-col items-center flex-grow mt-10 pb-16">
        <div class="max-w-2xl w-full bg-white px-6 py-4 rounded-md ring-1 ring-border shadow user-written-body"
            v-html="content" />
        <div class="mx-auto pb-2" v-if="$page.props.sidebar_logo">
            <img :class="'w-16 mt-14'" :src="$page.props.sidebar_logo" @error="() => console.error('Logo not found')" />
        </div>
    </div>
</template>

<script>
import LandingPageLayout from '@/Layouts/LandingPageLayout.vue'
export default {
    layout: LandingPageLayout,
    props: {
        content: {
            type: String,
            required: true,
        },
    },
}
</script>
